<template>

    <div>

        <skoly-menu
            @updateProfil="emitUpdateProfil"
            :profil="profil"
        />

        <main class="profileDashboard skolska-sekcia-main justify-content-center">

            <article>

                <aside class="rounded-10 main-banner banner-skoly position-relative">
                    <img src="assets/img/skolsky-banner-main.png" alt="" class="img-fluid">
                    <div class="position-absolute d-flex flex-column align-items-start">
                        <h2 class="mb-20">Veľa šťastia pri riešení úloh v školskej súťaži</h2>
                        <router-link :to="{ name: 'skoly-ulohy', params: { 'rocnik': profil.pouzivatel_id.pouzivatel_rocnik } }" class="btn --primary">
                            Riešiť úlohy
                        </router-link>
                        <div class="d-flex mt-auto">
                            <span class="icon icon--info text-icon mr-10 pt-5"></span>
                            <p class="mb-0 line-24">Pozrite sa každý mesiac, čo je tu nové</p>
                        </div>
                    </div>
                </aside>

            </article>
            <aside>

                <div class="m-skolskaKarta mb-30">
                    <h5 class="a-skolskaKarta__title">počet bodov</h5>
                    <div class="d-flex align-items-center justify-content-between">
                        <div class="a-skolskaKarta__value text-success">{{ profil.pouzivatel_id.pouzivatel_body }}</div>
                        <div class="a-skolskaKarta__button">
                            <router-link :to="{ name: 'skoly-body' }" class="btn --primary --circle">
                                <span class="icon --arrow-right"></span>
                            </router-link>
                        </div>
                    </div>
                </div>

                <div class="m-skolskaKarta mb-30">
                    <h5 class="a-skolskaKarta__title">vyplnené úlohy</h5>
                    <div class="d-flex align-items-center justify-content-between">
                        <div class="a-skolskaKarta__value text-danger">{{ uspesnost }}</div>
                        <div class="a-skolskaKarta__button">
                            <router-link :to="{ name: 'skoly-ulohy', params: { 'rocnik': profil.pouzivatel_id.pouzivatel_rocnik } }" class="btn --primary --circle">
                                <span class="icon --arrow-right"></span>
                            </router-link>
                        </div>
                    </div>

                </div>
                <div class="m-skolskaKarta">
                    <h5 class="a-skolskaKarta__title">žiakov v našej triede</h5>
                    <div class="d-flex align-items-center justify-content-between">
                        <div class="a-skolskaKarta__value">{{ profil.pouzivatel_id.pouzivatel_pocet_ziakov }}</div>
                        <div class="a-skolskaKarta__button">
                            <router-link :to="{ name: 'skoly-trieda' }" class="btn --primary --circle"><span class="icon --arrow-right"></span></router-link>
                        </div>
                    </div>
                </div>
            </aside>

        </main>

    </div>
</template>

<script>
import SkolyMenu from "@/components/skoly/SkolyMenu.vue";
import EventService from "@/services/EventService";

export default {
    components: {
        SkolyMenu,
    },
    props: [
        'profil',
    ],
    data() {
        return {
            uspesnost: 0
        }
    },
    mounted() {
        this.loadUspesnost()
    },
    methods: {
        // emit
        emitUpdateProfil() {
            this.$emit('updateProfil')
        },

        async loadUspesnost() {
            let { data } = await EventService.getUlohyUspesnost();
            this.uspesnost = data.uspesnost
        }
    }
}
</script>
